// @flow
import * as React from "react";
import type { TicketReservation } from "../../common/types";
import Alert from "@material-ui/lab/Alert";
import AlertTitle from "@material-ui/lab/AlertTitle";
import Box from "@material-ui/core/Box";
import { useFunctions } from "reactfire";
import TicketPayButton from "./TicketPayButton";
import Button from "@material-ui/core/Button";
import { useState } from "react";

type Props = {
  ticketReservation: TicketReservation,
  gameId: string,
  query: any,
  ticketReservationRef: any,
};

function TicketDetailsPayment({
  ticketReservation,
  query,
  ticketReservationRef,
  gameId,
}: Props) {
  const sessionId = query.get("session_id");
  const payment = query.get("payment");
  const functions = useFunctions();
  const [showAlert, setShowAlert] = useState(true);

  const checkForPayment = async () => {
    if (sessionId == null) {
      return "unpaid";
    }

    const checkForTicketReservationPayment = functions.httpsCallable(
      "checkForTicketReservationPayment"
    );

    const session = await checkForTicketReservationPayment({ sessionId }).catch(
      (error) => {
        console.error(error);
      }
    );

    const { data } = session;
    if (data != null && data.payment_status !== "unpaid") {
      return "paid";
    }

    return "unpaid";
  };

  const setPaymentSuccess = async () => {
    await ticketReservationRef
      .set({ paymentStatus: "COMPLETE" }, { merge: true })
      .catch((error) => {
        console.error(error);
      });
  };

  if (ticketReservation.paymentStatus === "COMPLETE") {
    return null;
  }

  if (payment === "success" && sessionId != null) {
    // check if payment was successfull and mimic a positiv behaviour
    const paymentStatus = checkForPayment();
    if (paymentStatus === "paid") {
      setPaymentSuccess().then(() => Promise.resolve());
    }
    return null;
  }

  // we consider it an error
  return showAlert ? (
    <Box mb={2}>
      <Alert severity="error" onClose={() => setShowAlert(false)}>
        <AlertTitle>Deine Zahlung ist fehlgeschlagen</AlertTitle>
        Keine Sorge, deine Tickets sind trotzdem reserviert. Du kannst die
        Zahlung erneut versuchen oder vor Ort an der Abendkasse in Bar zahlen.
        Deine Reservierung verfällt 15 Minuten vor Spielbeginn.
        <Box mt={1}>
          <TicketPayButton
            renderButton={(pay, loading) => (
              <Button
                variant="outlined"
                color="secondary"
                onClick={pay}
                disabled={loading}
              >
                Erneut versuchen
              </Button>
            )}
            gameId={gameId}
          />
        </Box>
      </Alert>
    </Box>
  ) : null;
}

export default TicketDetailsPayment;
